// Updated useDeleteAccount hook with reason support
import { useState } from "react";
import { useNavigate } from "react-router-dom";
export const useDeleteAccount = () => {
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();

  const deleteAccount = async (userId, reason = "") => {
    setIsDeleting(true);
    
    try {
      const response = await fetch(`https://stage.getrevibe.app/api/users/${userId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: JSON.stringify({ reason }), // Add reason to request body
      });

      if (response.ok) {
        localStorage.clear();
        navigate("/", { state: { message: "Account deleted successfully" } });
        return { success: true };
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to delete account");
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      return { success: false, error: error.message };
    } finally {
      setIsDeleting(false);
    }
  };

  return { deleteAccount, isDeleting };
};